import axios from './index';
import { gql } from '@apollo/client';
import { store } from '../index';

export const GET_HOSPITAL = gql`
    query GET_HOSPITAL($id: ID!) {
        hospital(id: $id) {
            id
            hospitalID
            name
            phoneNumber
            email
            address
            avatar {
                id
                url
            }
        }
    }
`;

export const UPDATE_HOSPITAL = gql`
    mutation UPDATE_HOSPITAL(
        $id: ID!
        $name: String!
        $email: String!
        $phoneNumber: String!
        $address: String!
    ) {
        updateHospital(
            input: {
                where: { id: $id }
                data: { name: $name, email: $email, phoneNumber: $phoneNumber, address: $address }
            }
        ) {
            hospital {
                id
                name
                email
                phoneNumber
                address
            }
        }
    }
`;

export const DELETE_HOSPITAL_AVATAR = gql`
    mutation DELETE_HOSPITAL_AVATAR($id: ID!) {
        updateHospital(input: { where: { id: $id }, data: { avatar: null } }) {
            hospital {
                id
                avatar {
                    id
                }
            }
        }
    }
`;

export const GET_TITLES = gql`
    query GET_TITLES {
        titles {
            id
            name
        }
    }
`;

export const GET_POSITIONS = gql`
    query GET_POSITIONS {
        staffPositions {
            id
            name
        }
    }
`;

export const GET_ROLES = gql`
    query GET_ROLES {
        staffRoles {
            id
            name
        }
    }
`;

export const DELETE_USER_AVATAR = gql`
    mutation DELETE_USER_AVATAR($id: ID!) {
        updateUser(input: { where: { id: $id }, data: { avatar: null } }) {
            user {
                id
                avatar {
                    id
                }
            }
        }
    }
`;

export const UPDATE_PROVIDER = gql`
    mutation UPDATE_PROVIDER(
        $userID: ID!
        $staffID: ID!
        $fullname: String
        $gender: String
        $email: String
        $mobileNumber: String
        $title1: ID
        $title2: ID
        $staffPosition: ID
        $staffRole: ID
        $specialist: JSON
        $workingExperiences: JSON
        $educationCertificates: JSON
    ) {
        updateUser(
            input: {
                where: { id: $userID }
                data: {
                    fullname: $fullname
                    gender: $gender
                    email: $email
                    mobileNumber: $mobileNumber
                }
            }
        ) {
            user {
                id
                fullname
                email
                gender
                mobileNumber
            }
        }
        updateStaff(
            input: {
                where: { id: $staffID }
                data: {
                    title1: $title1
                    title2: $title2
                    staff_position: $staffPosition
                    staff_role: $staffRole
                    specialist: $specialist
                    workingExperiences: $workingExperiences
                    educationCertificates: $educationCertificates
                }
            }
        ) {
            staff {
                id
                title1 {
                    name
                }
                title2 {
                    name
                }
                staff_role {
                    name
                }
                staff_position {
                    name
                }
                staff_role {
                    name
                }
                specialist
                hospital {
                    name
                }
            }
        }
    }
`;

export const GET_STAFFS = gql`
    query GET_STAFFS($id: ID!) {
        staffs(where: { hospital: $id, user_null: false }) {
            id
            deactivated
            user {
                id
                fullname
                avatar {
                    url
                }
            }
            staff_position {
                name
            }
            staff_role {
                name
            }
            specialist
            hospital {
                id
            }
        }
    }
`;
export const GET_PROVIDERS = gql`
    query GET_PROVIDERS($id: ID!) {
        staffs(
            where: {
                user_null: false
                deactivated: false
                hospital: $id
                staff_role: { name_in: ["Provider", "Provider Admin"] }
            }
        ) {
            id
            deactivated
            user {
                id
                fullname
                avatar {
                    url
                }
            }
            staff_position {
                name
            }
            staff_role {
                name
            }
            specialist
            hospital {
                id
            }
        }
    }
`;

export const GET_PROVIDER = gql`
    query GET_PROVIDER($id: ID!) {
        staff(id: $id) {
            id
            deactivated
            user {
                id
                fullname
                email
                gender
                mobileNumber
                avatar {
                    id
                    url
                }
            }
            title1 {
                name
            }
            title2 {
                name
            }
            staff_position {
                name
            }
            staff_role {
                name
            }
            specialist
            hospital {
                id
                name
            }
            workingExperiences
            educationCertificates
        }
    }
`;

export const GET_PATIENTS = gql`
    query GET_PATIENTS($id: ID!) {
        hospital(id: $id) {
            patients(where: { user_null: false }) {
                id
                HNCode
                user {
                    id
                    fullname
                    avatar {
                        url
                    }
                    uuid
                }
                patientTag
            }
        }
    }
`;

export const GET_PATIENT = gql`
    query GET_PATIENT($id: ID!) {
        patient(id: $id) {
            id
            user {
                id
                fullname
                birthday
                email
                mobileNumber
                gender
                IDCardNumber
                avatar {
                    id
                    url
                }
                uuid
                confirmed
            }
            patientTag
            weight
            height
            drugAllergy
            chronicDeseases1
            chronicDeseases2
            pregnant
            smoker
            drinker
            familyMedicalRecord
            emergencyContractNumber
            emergencyContractName
            emergencyContractRelation
            HNCode
            hospital {
                id
            }
        }
    }
`;

export const GET_PATIENT_HISTORY = gql`
    query GET_PATIENT_HISTORY($id: ID!, $startDate: Date!, $endDate: Date!) {
        sessions(
            where: {
                date_gte: $startDate
                date_lte: $endDate
                sessionEnd: true
                cancelled: false
                patient_summaries: { patient: $id }
            }
        ) {
            id
            date
            patient_summaries(where: { patient: $id }) {
                id
                joinTime
                leaveTime
                totalTime
                presentHistory
                medicalHistory
                familyHistory
                MSE
                diagnosis
                treatment
                noteToPsychiatrist
                noteToPatient
                homework
                session {
                    id
                    date
                    sessionEnd
                    name
                    description
                    meet {
                        id
                        name
                        description
                        staff {
                            id
                            user {
                                fullname
                            }
                        }
                        hospital {
                            name
                        }
                        type
                    }
                }
                patient {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                        gender
                        birthday
                        uuid
                    }
                    HNCode
                    patientTag
                }
            }
        }
    }
`;

export const GET_PATIENT_SUMMARY = gql`
    query GET_PATIENT_SUMMARY($id: ID!) {
        patientSummary(id: $id) {
            session_notes {
                id
                description
                emotions {
                    id
                    strEmotion
                }
                provider_tags {
                    name
                }
            }
        }
    }
`;

export const UPDATE_PATIENT = gql`
    mutation UPDATE_PATIENT(
        $userID: ID!
        $patientID: ID!
        $fullname: String
        $gender: String
        $email: String
        $mobileNumber: String
        $HNCode: String
        $IDCardNumber: String
        $birthday: Date
        $weight: Float
        $height: Float
        $drugAllergy: String
        $chronicDeseases1: String
        $chronicDeseases2: String
        $pregnant: Boolean
        $smoker: Boolean
        $drinker: Boolean
        $familyMedicalRecord: String
        $emergencyContractNumber: String
        $emergencyContractName: String
        $emergencyContractRelation: String
        $patientTag: JSON
    ) {
        updateUser(
            input: {
                where: { id: $userID }
                data: {
                    fullname: $fullname
                    gender: $gender
                    email: $email
                    mobileNumber: $mobileNumber
                    IDCardNumber: $IDCardNumber
                    birthday: $birthday
                }
            }
        ) {
            user {
                id
                fullname
                birthday
                email
                mobileNumber
                gender
                IDCardNumber
            }
        }
        updatePatient(
            input: {
                where: { id: $patientID }
                data: {
                    HNCode: $HNCode
                    weight: $weight
                    height: $height
                    drugAllergy: $drugAllergy
                    chronicDeseases1: $chronicDeseases1
                    chronicDeseases2: $chronicDeseases2
                    pregnant: $pregnant
                    smoker: $smoker
                    drinker: $drinker
                    familyMedicalRecord: $familyMedicalRecord
                    emergencyContractNumber: $emergencyContractNumber
                    emergencyContractName: $emergencyContractName
                    emergencyContractRelation: $emergencyContractRelation
                    patientTag: $patientTag
                }
            }
        ) {
            patient {
                id
                weight
                height
                drugAllergy
                chronicDeseases1
                chronicDeseases2
                pregnant
                smoker
                drinker
                familyMedicalRecord
                emergencyContractNumber
                emergencyContractName
                emergencyContractRelation
                HNCode
                hospital {
                    id
                }
                patientTag
            }
        }
    }
`;

export const DELETE_PATIENT = gql`
    mutation DELETE_PATIENT($id: ID!) {
        updatePatient(input: { where: { id: $id }, data: { published_at: null } }) {
            patient {
                id
                fullname
            }
        }
    }
`;

export const GET_PRIMARY_PATIENTS = gql`
    query GET_PRIMARY_PATIENTS($id: ID!) {
        staff(id: $id) {
            primaryPatients {
                id
                user {
                    id
                    fullname
                    avatar {
                        url
                    }
                    uuid
                }
                patientTag
                HNCode
            }
        }
    }
`;

export const UPDATE_PRIMARY_PATIENTS = gql`
    mutation UPDATE_PRIMARY_PATIENTS($id: ID!, $primaryPatients: [ID]!) {
        updateStaff(input: { where: { id: $id }, data: { primaryPatients: $primaryPatients } }) {
            staff {
                id
                primaryPatients {
                    id
                    user {
                        id
                        fullname
                    }
                }
            }
        }
    }
`;

export const GET_NOTES = gql`
    query GET_NOTES($id: ID!) {
        patientNotes(where: { patient: $id }) {
            id
            createdAt
            updatedAt
            description
            fromStaff {
                id
                user {
                    id
                    fullname
                }
            }
        }
    }
`;

export const CREATE_PATIENT_NOTE = gql`
    mutation CREATE_PATIENT_NOTE($description: String!, $provider: ID!, $patient: ID!) {
        createPatientNote(
            input: { data: { description: $description, fromStaff: $provider, patient: $patient } }
        ) {
            patientNote {
                id
            }
        }
    }
`;

export const UPDATE_PATIENT_NOTE = gql`
    mutation UPDATE_PATIENT_NOTE($id: ID!, $description: String!) {
        updatePatientNote(input: { where: { id: $id }, data: { description: $description } }) {
            patientNote {
                id
                description
            }
        }
    }
`;

export const DELETE_PATIENT_NOTE = gql`
    mutation DELETE_PATIENT_NOTE($id: ID!) {
        deletePatientNote(input: { where: { id: $id } }) {
            patientNote {
                id
                description
            }
        }
    }
`;
export const GET_CREDIT = gql`
    query GET_CREDIT($id: ID!) {
        hospital(id: $id) {
            credit
            updatedAt
        }
        topUps(where: { hospital: $id }, limit: 1, sort: "updatedAt:desc") {
            id
            amount
            type
            createdAt
            updatedAt
        }
    }
`;

export const GET_TRANSACTION = gql`
    query GET_TRANSACTION($id: ID!, $limit: Int!) {
        transactionsConnection(where: { hospital: $id }) {
            aggregate {
                count
            }
        }
        transactions(where: { hospital: $id }, limit: $limit, sort: "updatedAt:desc") {
            id
            createdAt
            updatedAt
            amount
            type
            consultationDuration
            staff {
                user {
                    fullname
                }
            }
        }
    }
`;

export const GET_TOP_UPS = gql`
    query GET_TOP_UPS($id: ID!, $limit: Int!) {
        topUpsConnection(where: { hospital: $id, status_in: ["APPROVED", "REJECTED"] }) {
            aggregate {
                count
            }
        }
        topUps(
            where: { hospital: $id, status_in: ["APPROVED", "REJECTED"] }
            limit: $limit
            sort: "updatedAt:desc"
        ) {
            id
            amount
            type
            createdAt
            updatedAt
            status
            number
            remark
        }
    }
`;

export const GET_TOP_UP = gql`
    query GET_TOP_UP($id: ID!) {
        topUp(id: $id) {
            id
            createdAt
            dueDate
            amount
            type
            status
            cost
            tax
            remark
            number
            businessName
            businessTAXID
            businessAddress
            businessPhone
            contactName
            contactEmail
            contactPhone
            hospital {
                id
                credit
                name
                hospitalID
                address
            }
        }
    }
`;

export const GET_PENDING = gql`
    query GET_PENDING($id: ID!) {
        topUps(
            where: { hospital: $id, status_in: ["CREATED", "SENT", "AWAIT"], type: "topUp" }
            sort: "updatedAt:desc"
        ) {
            id
            createdAt
            updatedAt
            type
            status
            amount
            number
            slip {
                id
                name
                url
            }
        }
    }
`;

export const NEXT_MEETS_COUNT = gql`
    query NEXT_MEETS_COUNT($today: Date!, $staff: ID, $hospital: ID!) {
        allCount: meetsConnection(
            where: { startDate_gte: $today, staff: $staff, hospital: $hospital, cancelled: false }
        ) {
            aggregate {
                count
            }
        }
        groupCount: meetsConnection(
            where: {
                startDate_gte: $today
                staff: $staff
                hospital: $hospital
                type: "group"
                cancelled: false
            }
        ) {
            aggregate {
                count
            }
        }
        oneCount: meetsConnection(
            where: {
                startDate_gte: $today
                staff: $staff
                hospital: $hospital
                type: "one"
                cancelled: false
            }
        ) {
            aggregate {
                count
            }
        }
        openCount: meetsConnection(
            where: {
                startDate_gte: $today
                staff: $staff
                hospital: $hospital
                type: "open"
                cancelled: false
            }
        ) {
            aggregate {
                count
            }
        }
    }
`;

export const REPORT_COUNT = gql`
    query REPORT_COUNT($staff: ID, $hospital: ID!) {
        sessionsConnection(
            where: {
                sessionEnd: true
                cancelled: false
                meet: { staff: $staff, hospital: $hospital, type_ne: "open" }
            }
        ) {
            aggregate {
                count
            }
        }
    }
`;

export const GET_TODAY_SESSIONS = gql`
    query GET_TODAY_SESSIONS($today: Date!, $staff: ID, $hospital: ID!, $endTime: Time!) {
        sessions(
            where: {
                date: $today
                sessionEnd: false
                cancelled: false
                endTime_gte: $endTime
                meet: { staff: $staff, hospital: $hospital, cancelled: false }
            }
        ) {
            id
            date
            sessionEnd
            cancelled
            startTime
            endTime
            roomId
            meet {
                id
                type
                cancelled
                startTime
                endTime
                name
                patients {
                    id
                    user {
                        id
                        fullname
                        avatar {
                            url
                        }
                    }
                }
                staff {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                    hospital {
                        name
                    }
                }
            }
        }
    }
`;

export const GET_UPCOMMING = gql`
    query GET_UPCOMMING($today: Date!, $staff: ID, $hospital: ID!) {
        sessions(
            where: {
                sessionEnd: false
                cancelled: false
                date_gt: $today
                meet: { staff: $staff, hospital: $hospital, cancelled: false }
            }
            sort: "date:asc"
        ) {
            id
            name
            date
            startTime
            endTime
            sessionEnd
            cancelled
            meet {
                id
                type
                cancelled
                startTime
                endTime
                name
                patients {
                    id
                    user {
                        id
                        fullname
                        avatar {
                            url
                        }
                    }
                }
                staff {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                    hospital {
                        name
                    }
                }
            }
        }
    }
`;

export const GET_OTHER_HOSPITAL_SESSIONS = gql`
    query GET_OTHER_HOSPITAL_SESSIONS($today: Date!, $hospital: ID!) {
        sessions(
            where: {
                sessionEnd: false
                cancelled: false
                date_gt: $today
                meet: { type: "open", hospital_ne: $hospital, cancelled: false }
            }
            sort: "date:asc"
        ) {
            id
            name
            date
            startTime
            endTime
            sessionEnd
            cancelled
            meet {
                id
                type
                cancelled
                startTime
                endTime
                name
                staff {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                    hospital {
                        name
                    }
                }
            }
        }
    }
`;

export const GET_OTHER_SESSIONS = gql`
    query GET_OTHER_SESSIONS($today: Date!, $staffId: ID!) {
        sessions(
            where: {
                sessionEnd: false
                cancelled: false
                date_gte: $today
                meet: { type: "open", cancelled: false, staff: { id_ne: $staffId } }
            }
            sort: "date:asc"
        ) {
            id
            name
            date
            startTime
            endTime
            sessionEnd
            cancelled
            patient_summaries {
                id
            }
            meet {
                id
                type
                cancelled
                startTime
                endTime
                name
                staff {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                    hospital {
                        name
                    }
                }
            }
        }
    }
`;

export const GET_OTHER_SESSION_DETAIL = gql`
    query GET_OTHER_SESSION_DETAIL($id: ID!) {
        session(id: $id) {
            id
            sessionEnd
            cancelled
            roomId
            actualEndTime
            meet {
                id
                name
                description
                type
                cancelled
                sessionType
                startDate
                endDate
                startTime
                endTime
                rules
                numberOfParticipants
                staff {
                    id
                    specialist
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                }
            }
        }
    }
`;

export const GET_ONE_ON_ONE_MEETS = gql`
    query GET_ONE_ON_ONE_MEETS($startDate: Date!, $endDate: Date!, $staff: ID, $hospital: ID!) {
        meets(
            where: {
                type: "one"
                startDate_gte: $startDate
                endDate_lte: $endDate
                staff: $staff
                hospital: $hospital
            }
            sort: "startDate:asc"
        ) {
            id
            type
            name
            description
            startDate
            endDate
            startTime
            endTime
            staff {
                user {
                    fullname
                    avatar {
                        url
                    }
                }
            }
            patients {
                id
                user {
                    fullname
                    avatar {
                        url
                    }
                }
            }
            sessions {
                id
                name
                date
                startTime
                endTime
            }
        }
    }
`;

export const GET_GROUP_MEETS = gql`
    query GET_GROUP_MEETS($startDate: Date!, $endDate: Date!, $staff: ID, $hospital: ID!) {
        meets(
            where: {
                type: "group"
                startDate_gte: $startDate
                endDate_lte: $endDate
                staff: $staff
                hospital: $hospital
            }
            sort: "startDate:asc"
        ) {
            id
            type
            name
            description
            startDate
            endDate
            startTime
            endTime
            staff {
                user {
                    fullname
                    avatar {
                        url
                    }
                }
            }
            patients {
                id
                user {
                    fullname
                    avatar {
                        url
                    }
                }
            }
            sessions {
                id
                name
                date
                startTime
                endTime
            }
        }
    }
`;

export const GET_OPEN_SESSIONS = gql`
    query GET_OPEN_SESSIONS($startDate: Date!, $endDate: Date!, $staff: ID, $hospital: ID!) {
        sessions(
            where: {
                date_gte: $startDate
                date_lte: $endDate
                sessionEnd: false
                meet: { type: "open", staff: $staff, hospital: $hospital }
            }
            sort: "date:asc"
        ) {
            id
            name
            date
            startTime
            endTime
            sessionEnd
            cancelled
            meet {
                id
                type
                name
                numberOfParticipants
                description
                patients {
                    id
                    user {
                        id
                        fullname
                        avatar {
                            url
                        }
                    }
                }
            }
        }
    }
`;

export const GET_ENDED_SESSIONS = gql`
    query GET_ENDED_SESSIONS($startDate: Date!, $endDate: Date!, $staff: ID, $hospital: ID!) {
        sessions(
            where: {
                date_gte: $startDate
                date_lte: $endDate
                sessionEnd: true
                cancelled: false
                meet: { staff: $staff, hospital: $hospital, type_in: ["one", "group"] }
            }
            sort: "date:asc"
        ) {
            id
            name
            date
            startTime
            endTime
            sessionEnd
            meet {
                id
                type
                name
                patients {
                    id
                    user {
                        id
                        fullname
                        avatar {
                            url
                        }
                    }
                }
            }
        }
    }
`;

export const GET_SESSION = gql`
    query GET_SESSION($id: ID!) {
        session(id: $id) {
            id
            date
            startTime
            endTime
            actualStartTime
            actualEndTime
            sessionEnd
            cancelled
            name
            description
            meet {
                cancelled
                staff {
                    user {
                        fullname
                    }
                }
            }
            session_notes {
                id
                createdAt
                description
                emotions {
                    id
                    strEmotion
                }
                provider_tags {
                    id
                    name
                }
                patient {
                    id
                    user {
                        id
                        fullname
                        uuid
                    }
                }
            }
            patient_summaries {
                id
                presentHistory
                medicalHistory
                familyHistory
                MSE
                diagnosis
                treatment
                noteToPatient
                noteToPsychiatrist
                homework
                patient {
                    id
                    patientTag
                    emergencyContractName
                    emergencyContractNumber
                    emergencyContractRelation
                    user {
                        id
                        fullname
                        avatar {
                            url
                        }
                        uuid
                    }
                }
                mindgymHomework
                nextAppointment
            }
        }
    }
`;

export const GET_CALL_SESSION_DETAIL = gql`
    query GET_CALL_SESSION_DETAIL($id: ID!) {
        session(id: $id) {
            id
            date
            startTime
            endTime
            actualStartTime
            actualEndTime
            sessionEnd
            cancelled
            name
            description
            meet {
                id
                cancelled
                name
                rules
                staff {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                }
                otherStaffs(where: { user_null: false }) {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                }
                patients(where: { user_null: false }) {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                    HNCode
                    patient_summaries(
                        where: {
                            session: { sessionEnd: true }
                            noteToPatient_null: false
                            noteToPatient_ne: ""
                        }
                        limit: 1
                        sort: "createdAt:desc"
                    ) {
                        id
                        presentHistory
                        medicalHistory
                        familyHistory
                        MSE
                        diagnosis
                        treatment
                        joinTime
                        leaveTime
                        totalTime
                        noteToPatient
                        noteToPsychiatrist
                        homework
                        session {
                            date
                            sessionEnd
                            name
                            description
                            meet {
                                name
                                description
                                staff {
                                    user {
                                        fullname
                                    }
                                }
                                hospital {
                                    name
                                }
                            }
                        }
                    }
                }
            }
            session_notes {
                id
                createdAt
                description
                emotions {
                    id
                    strEmotion
                }
                provider_tags {
                    id
                    name
                }
                patient {
                    id
                    user {
                        fullname
                        uuid
                    }
                    patientTag
                }
            }
            patient_summaries {
                id
                joinTime
                leaveTime
                presentHistory
                medicalHistory
                familyHistory
                MSE
                diagnosis
                treatment
                noteToPatient
                noteToPsychiatrist
                homework
                patient {
                    id
                }
            }
        }
    }
`;

export const UPDATE_PATIENT_SUMMARY = gql`
    mutation UPDATE_PATIENT_SUMMARY(
        $id: ID!
        $MSE: String
        $diagnosis: String
        $treatment: String
        $noteToPsychiatrist: String
        $noteToPatient: String
        $homework: String
        $mindgymHomework: JSON
        $nextAppointment: JSON
    ) {
        updatePatientSummary(
            input: {
                where: { id: $id }
                data: {
                    MSE: $MSE
                    diagnosis: $diagnosis
                    treatment: $treatment
                    noteToPsychiatrist: $noteToPsychiatrist
                    noteToPatient: $noteToPatient
                    homework: $homework
                    mindgymHomework: $mindgymHomework
                    nextAppointment: $nextAppointment
                }
            }
        ) {
            patientSummary {
                id
                presentHistory
                medicalHistory
                familyHistory
                MSE
                diagnosis
                treatment
                noteToPatient
                noteToPsychiatrist
                homework
                mindgymHomework
                nextAppointment
            }
        }
    }
`;

export const GET_EMOTIONS = gql`
    query GET_EMOTIONS {
        emotions {
            id
            strEmotion
            intEmotion
        }
    }
`;

export const GET_PROVIDER_TAGS = gql`
    query GET_PROVIDER_TAGS($id: ID!) {
        providerTags(where: { staff: $id }) {
            id
            name
            staff {
                id
                user {
                    fullname
                }
            }
        }
    }
`;

export const CREATE_PROVIDER_TAG = gql`
    mutation CREATE_PROVIDER_TAG($id: ID!, $tag: String!) {
        createProviderTag(input: { data: { staff: $id, name: $tag } }) {
            providerTag {
                id
                staff {
                    id
                    user {
                        fullname
                    }
                }
                name
            }
        }
    }
`;

export const GET_CALENDARS = gql`
    query GET_CALENDARS(
        $staff: ID
        $hospital: ID!
        $startDate: Date!
        $endDate: Date!
        $withScheduel: Boolean!
    ) {
        calendars(
            where: {
                staff: { id: $staff, hospital: $hospital }
                date_gte: $startDate
                date_lte: $endDate
            }
        ) {
            id
            staff {
                id
                user {
                    fullname
                }
                hospital {
                    id
                }
            }
            date
            appointment @include(if: $withScheduel)
            walkIn @include(if: $withScheduel)
            onlineStart @include(if: $withScheduel)
            onlineEnd @include(if: $withScheduel)
            breakStart @include(if: $withScheduel)
            breakEnd @include(if: $withScheduel)
            meets {
                id
                type
                name
                startDate
                startTime
                endTime
                cancelled
                patients(where: { user_null: false }) {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                }
                staff {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                }
                hospital {
                    name
                }
            }
        }
    }
`;

export const GET_CALENDAR = gql`
    query GET_CALENDAR($staff: ID!, $date: Date!, $meet: ID) {
        calendars(where: { staff: $staff, date: $date }) {
            id
            staff {
                id
            }
            date
            appointment
            walkIn
            onlineStart
            onlineEnd
            breakStart
            breakEnd
            meets(where: { cancelled: false, id_ne: $meet }) {
                id
                startDate
                endDate
                startTime
                endTime
                name
                description
            }
        }
    }
`;

export const UPDATE_SESSION = gql`
    mutation UPDATE_SESSION(
        $id: ID!
        $roomId: String
        $actualStartTime: DateTime
        $actualEndTime: DateTime
    ) {
        updateSession(
            input: {
                where: { id: $id }
                data: {
                    roomId: $roomId
                    actualStartTime: $actualStartTime
                    actualEndTime: $actualEndTime
                }
            }
        ) {
            session {
                id
                roomId
                actualStartTime
                actualEndTime
                sessionEnd
            }
        }
    }
`;

export const GET_PATIENTS_AND_PRIMARY_PATIENTS = gql`
    query GET_PATIENTS_AND_PRIMARY_PATIENTS($hospitalId: ID!, $staffId: ID!) {
        hospital(id: $hospitalId) {
            patients(where: { user_null: false }) {
                id
                user {
                    id
                    fullname
                    avatar {
                        url
                    }
                    uuid
                }
                patientTag
                HNCode
            }
        }
        staff(id: $staffId) {
            primaryPatients(where: { user_null: false }) {
                id
                user {
                    id
                    fullname
                    avatar {
                        url
                    }
                    uuid
                }
                patientTag
                HNCode
            }
        }
    }
`;

export const GET_MEET = gql`
    query GET_MEET($id: ID!) {
        meet(id: $id) {
            id
            name
            description
            type
            startDate
            endDate
            startTime
            endTime
            rules
            numberOfParticipants
            sessionType
            staff {
                id
            }
            patients(where: { user_null: false }) {
                id
                user {
                    fullname
                }
            }
            sessions {
                id
                actualStartTime
                actualEndTime
                startTime
                endTime
                roomId
                patient_summaries {
                    id
                    checkinTime
                    patient {
                        id
                        HNCode
                        user {
                            fullname
                            avatar {
                                url
                            }
                            uuid
                        }
                    }
                }
            }
        }
    }
`;

export const GET_MEET_REPORT = gql`
    query GET_MEET_REPORT($id: ID!) {
        meet(id: $id) {
            id
            name
            description
            type
            startDate
            endDate
            startTime
            endTime
            rules
            staff {
                id
                user {
                    id
                    fullname
                    avatar {
                        url
                    }
                }
            }
            patients {
                id
                user {
                    id
                    fullname
                    avatar {
                        url
                    }
                }
            }
            sessions {
                id
                roomId
                actualStartTime
                actualEndTime
                startTime
                endTime
                patient_summaries {
                    patient {
                        id
                        HNCode
                        user {
                            id
                            fullname
                            avatar {
                                url
                            }
                            uuid
                        }
                    }
                }
                session_notes {
                    id
                    createdAt
                    patient {
                        user {
                            fullname
                            uuid
                        }
                    }
                    description
                    emotions {
                        id
                        strEmotion
                    }
                    provider_tags {
                        id
                        name
                    }
                }
            }
        }
    }
`;

export const GET_SESSION_DETAL_MEET = gql`
    query GET_SESSION_DETAL_MEET($id: ID!) {
        meet(id: $id) {
            id
            name
            description
            type
            sessionType
            cancelled
            startDate
            endDate
            startTime
            endTime
            rules
            numberOfParticipants
            staff {
                id
                user {
                    fullname
                    avatar {
                        url
                    }
                }
            }
            patients {
                id
                user {
                    fullname
                    avatar {
                        url
                    }
                }
            }
            sessions {
                id
                startTime
                endTime
                actualStartTime
                actualEndTime
                sessionEnd
                cancelled
                roomId
                patient_summaries {
                    id
                    checkinTime
                    patient {
                        id
                        user {
                            fullname
                            avatar {
                                url
                            }
                            uuid
                        }
                    }
                }
            }
        }
    }
`;

export const GET_MEETS_BY_DATE = gql`
    query GET_MEETS_BY_DATE($date: Date!, $staff: ID!) {
        meets(where: { cancelled: false, startDate: $date, staff: $staff }) {
            id
            startDate
            endDate
            startTime
            endTime
            name
            description
            cancelled
            staff {
                id
                user {
                    fullname
                }
            }
        }
    }
`;

export const GET_STAFF_MESSAGES = gql`
    query GET_STAFF_MESSAGES($id: ID!) {
        staff(id: $id) {
            id
            messages {
                id
                createdAt
                sender
                receiver
                text
                image {
                    url
                }
                isRead
                senderRole
                staff {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                    }
                    deactivated
                }
                patient {
                    id
                    user {
                        fullname
                        avatar {
                            url
                        }
                        uuid
                    }
                }
            }
        }
    }
`;

export const GET_WORKOUT = gql`
    query GET_WORKOUT($id: ID!) {
        staff(id: $id) {
            id
            workout
        }
    }
`;

export const UPDATE_WORKOUT = gql`
    mutation UPDATE_WORKOUT($id: ID!, $workout: JSON!) {
        updateStaff(input: { where: { id: $id }, data: { workout: $workout } }) {
            staff {
                id
                workout
            }
        }
    }
`;

export const getReport = async (id) => {
    const res = await axios.get(`/face-detects/report/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const getGroupReport = async (id) => {
    const res = await axios.get(`/face-detects/group-report/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const clearPatientSummary = async (id) => {
    const res = await axios.put(
        `/patient-summaries/${id}`,
        { checkinTime: null },
        {
            headers: {
                authorization: `Bearer ${store.getState().strapiToken}`,
            },
        }
    );

    return res;
};
export const skipQueue = async (data) => {
    const res = await axios.post(`/patient-summaries/skip`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const updatePrimaryPatient = async (staffID, patientID) => {
    const res = await axios.post(
        `/primary-patient/update`,
        {
            staffID: staffID,
            patientID: patientID,
        },
        {
            headers: {
                authorization: `Bearer ${store.getState().strapiToken}`,
            },
        }
    );
    return res;
};

export const setPrimaryPatient = async (staffID, patientIDArr) => {
    const res = await axios.post(
        `/primary-patient/set`,
        {
            staffID: staffID,
            patientIDArr: patientIDArr,
        },
        {
            headers: {
                authorization: `Bearer ${store.getState().strapiToken}`,
            },
        }
    );
    return res;
};

export const addSessionNote = async (data) => {
    const res = await axios.post(`/session-notes`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const updateSessionNote = async (id, data) => {
    const res = await axios.put(`/session-notes/${id}`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const deleteSessionNote = async (id) => {
    const res = await axios.delete(`/session-notes/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const createOne = async (data) => {
    const res = await axios.post(`/one/create`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const editOne = async (data) => {
    const res = await axios.put(`/one/edit`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const deleteOne = async (id) => {
    const res = await axios.delete(`/one/delete/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const createGroup = async (data) => {
    const res = await axios.post(`/group/create`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const editGroup = async (data) => {
    const res = await axios.put(`/group/edit`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const deleteGroup = async (id) => {
    const res = await axios.delete(`/group/delete/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const createOpen = async (data) => {
    const res = await axios.post(`/open/create`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const editOpen = async (data) => {
    const res = await axios.put(`/open/edit`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const deleteOpen = async (id) => {
    const res = await axios.delete(`/open/delete/${id}`, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });

    return res;
};

export const addPatientByStaff = async (data) => {
    const res = await axios.post(`/patients/staffregister`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const addProviderByStaff = async (data) => {
    const res = await axios.post(`/staffs/staffregister`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const addStaffToHospital = async (data) => {
    const res = await axios.post(`/staffs/staffregister`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const canStart = async (data) => {
    const res = await axios.post(`/sessions/can-start`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};
export const updateRoomId = async (data) => {
    const res = await axios.post(`/sessions/update-room-id`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const endOneOnOneSession = async (data) => {
    const res = await axios.post(`/sessions/end-one`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const endGroupSession = async (data) => {
    const res = await axios.post(`/sessions/end-group`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const endOpenSession = async (data) => {
    const res = await axios.post(`/sessions/end-open`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const checkExistHNCode = async (data) => {
    const res = await axios.post(`/patients/check-hn`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const checkExistUser = async (data) => {
    const res = await axios.post(`/user/check-user`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const addExistUserToPatient = async (data) => {
    const res = await axios.post(`/patients/add-patient`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const addExistUserToStaff = async (data) => {
    const res = await axios.post(`/staffs/add-staff`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const sendNotificationSession = async (data) => {
    const res = await axios.post(`/notifications/session`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const createSlots = async (data) => {
    const res = await axios.post(`/calendars/create-slot`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};
export const checkLastAdmin = async (data) => {
    const res = await axios.post(`/staff-roles/last-admin`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const deleteStaff = async (data) => {
    const res = await axios.post(`/staffs/delete-staff`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const deactivateStaff = async (data) => {
    const res = await axios.post(`/staffs/deactivate`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const removePatient = async (data) => {
    const res = await axios.post(`/patients/remove`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};
export const syncUserMindGym = async (data) => {
    const res = await axios.post(`/sync`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const topUpInquiry = async (data) => {
    const res = await axios.post(`/top-ups/inquiry`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};

export const topUpUploadSlip = async (form) => {
    const res = await axios.post(`/top-ups/slip`, form, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
            'Content-Type': 'multipart/form-data',
        },
    });

    return res;
};

export const cancelTopUp = async (data) => {
    const res = await axios.post(`/top-ups/cancel`, data, {
        headers: {
            authorization: `Bearer ${store.getState().strapiToken}`,
        },
    });
    return res;
};
